import React, { Component } from "react";
import { withRouter } from "react-router";
import { Card, Button, Form, Popover, Input } from "antd";
const FormItem = Form.Item;
import { QuestionCircleOutlined } from "@ant-design/icons";
import DateRangePicker from "../common/date-range-picker";
import MultiSelect from "../common/multi-select";
import { getDistinctValues } from "../../services/api-upc";

const TYPE_ACTIONS = [
  'Proceeding - Application for an Order for inspection pursuant to RoP199',
  'Proceeding - Application for preserving evidence pursuant to RoP192',
  'Proceeding - Application for provisional measures',
  'Proceeding - Counterclaim for revocation',
  'Proceeding - Infringement Action',
  'Proceeding - Revocation Action',
  'Application - Application RoP262.1',
  'Application - Application Rop262A',
  'Application - Application for registration as a Representative before the UPC (RoP286)',
  'Application - Application to amend a patent',
  'Application - Application to change a representative (RoP293)',
  'Application - Application RoP262-2',
  'Application - Correction of an opt-out',
  'Application - Correction of withdrawal of an opt-out',
  'Application - Generic Application',
  'Application - Manage panel',
  'Application - Preliminary objection',
  'Appeal - Appeal RoP220.1',
  'Appeal - Appeal RoP220.2',
];

const propsToStates = q => ({
  // convert url query to states
  inputCaseNumber: q.case_number,
  inputPatentNumber: q.patent_number,
  inputFilingDate: q.filing_date,
  inputActionApplicationType: q.action_application_type,
  inputRespondent: q.respondent,
  inputClaimant: q.claimant,
  inputRepresentatives: q.representatives,
  inputJudges: q.judges,
  fullText: q["documents.full_text"]
});

const stateKey2Field = {
  inputCaseNumber: "case_number",
  inputPatentNumber: "patent_number",
  inputFilingDate: "filing_date",
  inputActionApplicationType: "action_application_type",
  inputRespondent: "respondent",
  inputClaimant: "claimant",
  inputRepresentatives: "representatives",
  inputJudges: "judges"
};

class UPCToolbar extends Component {
  state = propsToStates(this.props.location.query);

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(propsToStates(nextProps.location.query));
  }

  render() {
    const fullTextHelp = (
      <table>
        <tbody>
          <tr>
            <td>
              <strong>Symbol</strong>
            </td>
            <td>
              <strong>Operation</strong>
            </td>
          </tr>
          <tr>
            <td>
              <code>&quot;</code>
            </td>
            <td>exact phrase</td>
          </tr>
          <tr>
            <td>
              <code>+</code> or <code>&lt;space&gt;</code>
            </td>
            <td>AND</td>
          </tr>
          <tr>
            <td>
              <code>|</code>
            </td>
            <td>OR</td>
          </tr>
          <tr>
            <td>
              <code>-</code>
            </td>
            <td>NOT</td>
          </tr>
          <tr>
            <td>
              <code>( )</code>
            </td>
            <td>groups search terms or operations</td>
          </tr>
          <tr>
            <a href="https://support.unifiedpatents.com/hc/en-us/articles/115003821454?flash_digest=a2e028e09a26171ea0403b4e9e6dbc32a19a65fc" target="_new">
              More details here.
            </a>
          </tr>
        </tbody>
      </table>
    );
    const fullTextLabel = (
      <span>
        {"FULL TEXT "}
        <Popover placement="rightBottom" title={"Advanced Query Syntax"} content={fullTextHelp} trigger="click">
          <QuestionCircleOutlined style={{ cursor: "pointer" }} />
        </Popover>
      </span>
    );

    return (
      <Card
        title={
          <span>
            {" UPC"}
          </span>
        }
        extra={
          <Button size="small" onClick={this._onResetClick}>
            {"Reset"}
          </Button>
        }
      >
        <Form layout="vertical">
          <FormItem label={fullTextLabel}>
            <Input value={this.state.fullText} placeholder="e.g. central division" onChange={e => this.setState({ fullText: e.target.value })} onPressEnter={this._onSearchClick} />
          </FormItem>
          {this.renderSelectFormItem("inputCaseNumber", "Case", "e.g. ACT_459505/2023")}
          {this.renderSelectFormItem("inputPatentNumber", "Patent", "e.g. EP-3666797-B1")}
          {this.renderSelectFormItem("inputActionApplicationType", "Action", "e.g. Revocation Action", TYPE_ACTIONS)}
          {this.renderSelectFormItem("inputRespondent", "Respondent", "e.g. Amgen, Inc.")}
          {this.renderSelectFormItem("inputClaimant", "Claimant", "e.g. Sanofi-Aventis Deutschland GmbH")}
          {this.renderSelectFormItem("inputRepresentatives", "Representatives", "e.g. Daniel Wise")}
          {this.renderSelectFormItem("inputJudges", "Judges", "e.g. Paolo Catallozzi")}
          {this.renderDateFormItem("inputFilingDate", "Filing Date")}
        </Form>
      </Card>
    );
  }

  renderActionLabel = () => {
    const categoryText = (
      <table>
        <tbody>
          <tr>
            <td>
              <code>Matters before the UPC can fall under two main "types":  proceedings and applications.</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>Applications can be for routine legal filings such as change of counsel.</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>Proceedings are categorized into "actions" and are typically requests for legal determinations such as infringement and validity.</code>
            </td>
          </tr>
        </tbody>
      </table>
    );
    return (
      <span>
        {"Action "}
        <Popover placement="right" title={"FAQ"} content={categoryText} trigger="click">
          <QuestionCircleOutlined style={{ cursor: "pointer" }} />
        </Popover>
      </span>
    );
  }

  renderSelectFormItem = (key, label, placeholder, options, valueRenderer) => (
    <Form.Item label={key === "inputActionApplicationType" ? this.renderActionLabel() : label}>
      <MultiSelect
        value={this.state[key]}
        onChange={(newValues) => {
          const filteredSelectAll = newValues.filter(val => val.includes("select-all"));
          if (filteredSelectAll.length > 0) {
            const actualValues = newValues.filter((val) => !val.includes("select-all"));
            for (var i = 0; i < TYPE_ACTIONS.length; i++) {
              const [type, action] = TYPE_ACTIONS[i].split(" - ");
              if (filteredSelectAll.includes(`select-all-${type}`) && !actualValues.includes(action)) {
                actualValues.push(action);
              }
            }

            this._handleSelectChange(key, actualValues);
          } else {
            this._handleSelectChange(key, newValues);
          }
        }}
        options={options}
        optionApiCall={options ? undefined : val => getDistinctValues(stateKey2Field[key], val)}
        optionRender={valueRenderer}
        placeholder={placeholder}
        displayGroups={key === "inputActionApplicationType"}
      />
    </Form.Item>
  );

  renderDateFormItem = (key, label) => (
    <Form.Item label={label}>
      <DateRangePicker value={this.state[key]} onChange={(e) => this._handleSelectChange(key, e)} allowClear={true} />
    </Form.Item>
  );

  _handleSelectChange = (stateKey, e) =>
    this.setState(
      {
        [stateKey]: e
      },
      this._onSearchClick
    );

  _onSearchClick = () => {
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: {
        case_number: this.state.inputCaseNumber,
        patent_number: this.state.inputPatentNumber,
        filing_date: this.state.inputFilingDate,
        action_application_type: this.state.inputActionApplicationType,
        respondent: this.state.inputRespondent,
        claimant: this.state.inputClaimant,
        representatives: this.state.inputRepresentatives,
        judges: this.state.inputJudges,
        "documents.full_text": this.state.fullText,
        sort: this.props.location.query.sort ? this.props.location.query.sort : "-filing_date"
      }
    });
  };

  _onResetClick = () =>
    this.setState(
      {
        inputCaseNumber: null,
        inputPatentNumber: null,
        inputPatentTitle: null,
        inputFilingDate: null,
        inputActionApplicationType: null,
        inputRespondent: null,
        inputClaimant: null,
        inputRepresentatives: null,
        inputJudges: null,
        fullText: null
      },
      () => {
        this.props.router.push({
          pathname: this.props.location.pathname,
          query: {
            sort: this.props.location.query.sort,
            action_application_type: [
              'Application for an Order for inspection pursuant to RoP199',
              'Application for preserving evidence pursuant to RoP192',
              'Application for provisional measures',
              'Counterclaim for revocation',
              'Infringement Action',
              'Revocation Action',
              'Appeal RoP220.1',
              'Appeal RoP220.2',
              'Application to amend a patent'
            ]
          }
        });
      }
    );
}

export default withRouter(UPCToolbar);